<script setup>
import {ref, reactive, onBeforeMount} from "vue"
import YTCard from "@/components/YTCard/YTCard.vue";
import router from "@/router/index.js";
import {addOrdinaryAdmin} from "@/api/user/user.js";
import validatorRules from "@/utils/validator-rules.js";

onBeforeMount(async () => {

})

// 表单加载状态
const loading = ref(false);

// 表单组件锚点
const ruleFormRef = ref()
// 对话框表单校验规则
const checkPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入账号/手机号'))
    return
  }
  if (!validatorRules.isPhone(value)) {
    callback(new Error('手机号码格式不正确'))
    return
  }
  callback()
}

// 表单信息
const ruleForm = reactive({
  nickname: null,
  username: null,
  tenantId: 0
})
// 表单校验规则
const rules = reactive({
  nickname: [
    {required: true, message: "请输入用户名", trigger: "blur"}
  ],
  username: [
    {required: true, validator: checkPhone, trigger: "blur"}
  ]
})
// 取消新增
const cancelAdd = () => {
  router.back()
}
// 保存校验表单
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        let param = {
          ...ruleForm
        }
        await addOrdinaryAdmin(param)
        ElMessage.success("新增用户成功")
        router.push("/listOrdinary")
      } catch (e) {
        loading.value = false
      }
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}

</script>

<template>
  <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm container_form mg_b_3"
      size="large"
      v-loading="loading">
    <YTCard :title="'用户信息'" :is-show-divider="false">
      <template #container>
        <el-form-item label="用户名" prop="nickname">
          <el-input maxlength="10" style="width: 300px" show-word-limit v-model="ruleForm.nickname" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="username">
          <el-input maxlength="11" style="width: 300px" show-word-limit v-model="ruleForm.username" placeholder="请输入账号/手机号"></el-input>
        </el-form-item>
      </template>
    </YTCard>
    <v-row class="mg_t_2">
      <v-col cols="4">
        <v-row>
          <v-col cols="6">
            <v-btn @click="cancelAdd">取消</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="primary" @click="submit" :disabled="!$handleHasBtnPermission('all', 'ordinaryAdmin:add')">保存</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </el-form>
</template>

<style lang="scss" scoped>
.btn_check {
  width: 28px;
  height: 28px;
  border-radius: 36px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  z-index: 100;
  background-color:#4caf50;
  display: flex;
  justify-content: center;
  align-items: center;
}

::marker {
  content: none;
}
</style>